<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false" width="70%">
  <el-card shadow="never" class="aui-card--fill">
    <div class="mod-parentStarLicense__onlineCourseSection">
      <el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()">
        <el-form-item>
          <el-input v-model="dataForm.sectionName" placeholder="课节名称" clearable></el-input>
        </el-form-item>
        <el-form-item>
          <el-button @click="getDataList()">{{ $t('query') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('parentStarLicense:onlineCourseSection:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
        </el-form-item>
        <el-form-item>
          <el-button v-if="$hasPermission('parentStarLicense:onlineCourseSection:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
        </el-form-item>
      </el-form>
      <el-table v-loading="dataListLoading" :data="dataList" border @selection-change="dataListSelectionChangeHandle" style="width: 100%;">
        <el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="sectionName" label="课节名称" header-align="center" align="center"></el-table-column>
        <el-table-column prop="videoSrc" label="视频地址" header-align="center" align="center">
          <template slot-scope="scope">
            <video width="100%" v-if="scope.row.videoSrc" controls="controls">
              <source :src="scope.row.videoSrc" type="video/mp4" />
            </video>
          </template>
        </el-table-column>
        <el-table-column prop="score" label="积分" header-align="center" align="center"></el-table-column>
        <el-table-column prop="weight" label="排序" header-align="center" align="center"></el-table-column>
        <el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('parentStarLicense:onlineCourseSection:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
            <el-button v-if="$hasPermission('parentStarLicense:onlineCourseSection:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
      <!-- 弹窗, 新增 / 修改 -->
      <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    </div>
  </el-card>
  </el-dialog>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './onlinecoursesection-add-or-update'
export default {
  mixins: [mixinViewModule],
  data () {
    return {
      visible: false,
      mixinViewModuleOptions: {
        getDataListURL: '/parentStarLicense/onlineCourseSection/page',
        getDataListIsPage: true,
        exportURL: '/parentStarLicense/onlineCourseSection/export',
        deleteURL: '/parentStarLicense/onlineCourseSection',
        deleteIsBatch: true,
        createdIsNeed: false
      },
      dataForm: {
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.query()
    },
    // 新增 / 修改
    addOrUpdateHandle (id) {
      this.addOrUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.addOrUpdate.dataForm.id = id
        this.$refs.addOrUpdate.dataForm.onlineCourseId = this.dataForm.onlineCourseId
        this.$refs.addOrUpdate.init()
      })
    }
  },
  watch: {
  },
  components: {
    AddOrUpdate
  }
}
</script>
